<app-section-header title="Validados" />
<div class="table-container">
  <p-table [value]="data">
    <ng-template pTemplate="header">
      <tr>
        <th>SETOR</th>
        <th>EMITIDO</th>
        <th>VALIDADO</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-tickets>
      <tr>
        @if (tickets.sector_title === "Guests") {
          <td>Convites</td>
        } @else {
          <td>{{ tickets.sector_title }}</td>
        }
        <td>{{ tickets.total_emitted }}</td>
        <td>{{ tickets.total_validated }}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="footer">
      <tr>
        <td>Total</td>
        <td>
          <b>{{ totalIssued }}</b>
        </td>
        <td>
          <b>{{ totalValidated }}</b>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
